module.exports = __webpack_public_path__ + "img/sawManCloud.593db65d.png";